import { isNull } from '@/shared/utils/utils';
import { IMailWizzEntity } from '../common/mailwizz-entity';
import { INamedEntity } from '../common/named-entity';

export class DeliveryServer implements IMailWizzEntity, INamedEntity {
    name: string;
    mailWizzEntityId: number;
    fromName: string;
    fromEmail: string;
    replyTo: string;
    trackingDomainId: number;
    usedRecently: number;
    status: string;
    
    get esp() {
        const parts = this.name.split(' ');
        if (parts.length <= 3) return null;
        return parts.splice(0, 3).join(' ');
    }

    static parseJson(json: any): DeliveryServer {
        if (isNull(json)) { return null; }

        const { mailWizzEntityId, trackingDomainId, ...rest} = json

        const deliveryServer = Object.assign(new DeliveryServer(), rest)
        deliveryServer.mailWizzEntityId = parseInt(mailWizzEntityId)
        deliveryServer.trackingDomainId = parseInt(trackingDomainId)

        return deliveryServer;
    }
}
